import { PaymentAdjustment } from './payment-adjustment.model';

/**
 * Model used for processing order
 */
export class OrderItem {
  constructor(
    public id: string | number,
    public name: string,
    public qty: number,
    public unitPrice: number,
    public imgUrl: string,
    public description?: string
  ) {}
}

/**
 * Model used for processing order snapshot, which is a summary of the order at a specific point in time.
 */
export interface OrderSnapshot {
  items: readonly OrderItem[];
  adjustments: readonly PaymentAdjustment[];
  totalAmount: number;
  totalItems: number;
}
